/**
 * Login form validation utilities
 */

export interface LoginFormErrors {
  email_error: string;
  pass_error: string;
  persona_error: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: LoginFormErrors;
}

/**
 * Validate login form fields
 * @param email - User email
 * @param password - User password
 * @param persona - Selected persona
 * @returns Validation result with errors
 */
export const validateLoginForm = (
  email: string,
  password: string,
  persona: string
): ValidationResult => {
  const errors: LoginFormErrors = {
    email_error: "",
    pass_error: "",
    persona_error: "",
  };

  let isValid = true;

  if (!email) {
    errors.email_error = "Email is required";
    isValid = false;
  }

  if (!password) {
    errors.pass_error = "Password is required";
    isValid = false;
  }

  if (!persona) {
    errors.persona_error = "Please select a role";
    isValid = false;
  }

  return { isValid, errors };
};
